module.exports = __webpack_public_path__ + "static/media/introduce.0485ffe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程G7E/introduce.png
// module id = 710
// module chunks = 0